// Google Sheets submission for Creator Lab applications.
//
// This posts to a Google Apps Script Web App bound to your Sheet (the same
// endpoint used in the previous version). Paste your deployment URL below —
// it looks like: https://script.google.com/macros/s/AKfyc.../exec
//
// The Apps Script receives a JSON body with the fields below and appends a
// row to the sheet. Field keys are kept identical to the previous version so
// your existing script and columns keep working.
export const GOOGLE_SHEETS_ENDPOINT =
  'https://script.google.com/macros/s/AKfycbwctXQbA5B_t-Y5XOav-aTIYx1U7M9zdP7-mFIH-uzgHJ_C_9Kin5nDP4WhUoXbd_-OrQ/exec'

export interface ApplicationPayload {
  name: string
  contact: string
  social: string
  fit: string
}

export async function submitApplication(
  payload: ApplicationPayload,
): Promise<void> {
  if (
    !GOOGLE_SHEETS_ENDPOINT ||
    GOOGLE_SHEETS_ENDPOINT === 'PASTE_YOUR_APPS_SCRIPT_WEB_APP_URL_HERE'
  ) {
    throw new Error(
      'Google Sheets endpoint is not configured. Add your Apps Script Web App URL to GOOGLE_SHEETS_ENDPOINT in utils/googleSheets.ts.',
    )
  }

  // Apps Script Web Apps require a simple request to avoid a CORS preflight,
  // so we send the body as text/plain. The response is opaque under no-cors,
  // which is fine — the script still appends the row.
  await fetch(GOOGLE_SHEETS_ENDPOINT, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'text/plain;charset=utf-8',
    },
    body: JSON.stringify({
      ...payload,
      timestamp: new Date().toISOString(),
    }),
  })
}
